import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, Validators } from '@angular/forms';
import { SessionService } from '@domain/application/observable-services/session.service';
import { DocumentTypes } from '@domain/model/enums/document-type/cmp-link';
import { forceAffirmativeValidation } from '@modules/business-accounts/forms/outside-tax/outside-tax.form';
import { getDataCollectionFormInstance } from '@modules/business-accounts/forms/utils/data-collection/builders/data-collection-builder.class';
import { AssetLink } from '@utils/helpers/asset-cpm-link';

@Component({
  selector: 'ba-data-collection',
  templateUrl: './data-collection.component.html',
  styleUrls: ['./data-collection.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ]
})
export class DataCollectionComponent extends DocumentTypes(AssetLink()) implements OnInit, AfterViewInit {

  isLoading = false;
  seeMore = false;
  titleSeeMore = 'Ver más';
  showTaxResidence: boolean = false;
  notTaxResidence: boolean = false;
  doubleLegalRepresentative: boolean = false;
  showAskLegalRepresentative: boolean = false;

  @Output() stepDone = new EventEmitter<void>();

  constructor(
    private readonly sessionService: SessionService,
    private readonly controlContainer: ControlContainer) {
    super();
  }

  ngOnInit(): void {
    this.form.get('dataCollection')?.get('documentType')?.disable();
    this.form.get('dataCollection')?.get('documentType')?.setValue(this.DocumentType.DNI);
  }

  ngAfterViewInit(): void {
    this.collapseFrequentQuestions();
  }

  evtCollapseView(btn: any) {
    btn.preventDefault();
    this.seeMore = !this.seeMore;
    this.titleSeeMore = this.seeMore ? 'Ver menos' : 'Ver más';
    this.collapseSeeMoreLess();
  }

  collapseSeeMoreLess(existParam?: boolean) {
    const content = document.getElementsByClassName('collapse-div');
    for (let i = 0; i < content.length; i++) {
      let div = content[i] as HTMLDivElement;
      if (!existParam) {
        if (div.style.maxHeight) {
          div.style.maxHeight = '';
        } else {
          div.style.maxHeight = div.scrollHeight + "px";
        }
      } else {
        div.style.maxHeight = div.scrollHeight + "px";
      }
    }
  }

  collapseFrequentQuestions() {
    const coll = document.getElementsByClassName("collapsible");
    for (let i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", () => {
        let btn = coll[i] as HTMLDivElement | HTMLButtonElement;
        btn.classList.toggle("active");
        let contents = btn.nextElementSibling! as HTMLDivElement;
        if (contents.style.maxHeight) {
          contents.style.maxHeight = '';
        } else {
          contents.style.maxHeight = contents.scrollHeight + "px";
        }
        setTimeout(() => {
          this.collapseSeeMoreLess(true);
        }, 500);
      });
    }
  }

  changeTaxResidence(e: any) {
    if (e.target.value === 'true') {
      this.showTaxResidence = true;
      this.notTaxResidence = false;
    } else {
      this.showTaxResidence = false;
      this.notTaxResidence = true;
    }
  }

  changeLegalRepresentative(e: any) {
    if (e.target.value === 'true') this.doubleLegalRepresentative = false;
    else this.doubleLegalRepresentative = true;
  }

  blurNumberRuc() {
    const regexRuc = new RegExp(/^20/);
    const ruc = this.form.get('dataCollection')?.get('ruc')?.value as string;
    if (ruc.length === 11) {
      if (regexRuc.test(ruc)) {
        this.showAskLegalRepresentative = true;
        const ctrlRepresentative = new FormControl(null, [
          Validators.required,
          forceAffirmativeValidation
        ]);
        this.dataCollectionForm.addControl('representative', ctrlRepresentative);
      }
      else {
        this.showAskLegalRepresentative = false;
        this.doubleLegalRepresentative = false;
        this.dataCollectionForm.removeControl('representative');
      }
    } else {
      this.showAskLegalRepresentative = false;
      this.doubleLegalRepresentative = false;
      this.dataCollectionForm.removeControl('representative');
    }
  }

  onGoStartupDone() {
    const ruc = this.form.get('dataCollection')?.get('ruc')?.value as string;
    let personType = '';
    const regexPN = new RegExp(/^10/);
    const regexPJ = new RegExp(/^20/);
    if (regexPN.test(ruc)) personType = 'PN';
    if (regexPJ.test(ruc)) personType = 'PJ';
    this.sessionService.setCommonInfo = {
      ruc: ruc,
      documentType: this.form.get('dataCollection')?.get('documentType')?.value,
      documentNumber: this.form.get('dataCollection')?.get('documentNumber')?.value,
      personType: personType
    };
    this.sessionService.setCommonInfo = { documentNumber: this.form.get('dataCollection')?.get('documentNumber')?.value };
    this.stepDone.emit();
  }

  get form() {
    return (this.controlContainer as FormGroupDirective).form;
  }

  get dataCollectionForm() {
    return getDataCollectionFormInstance({ from: this.form });
  }
}